export default __webpack_public_path__ + "static/media/humanoid_tri.2925279d.obj";